/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-alert */
/* eslint-disable react/button-has-type */
/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useRef, useCallback, useState, useEffect } from 'react';
import { FormHandles } from '@unform/core';
import * as Yup from 'yup';
import { Form } from '@unform/web';
import { GoTriangleRight } from 'react-icons/go';
import { Mail } from '@material-ui/icons';

import Button from '../../components/Button';
import Select from '../../components/Select';
import Input from '../../components/Input';
import ModalMotiva from './Components/ModalMotiva';

import Accordion from '../../components/Accordion';
import { Container, Content, Blur } from '../../styles/components';
import { isValidCpf } from '../../utils/isValidCpf';
import { isValidCnpj } from '../../utils/isValidCnpj';
import {
  TitleSection,
  Main,
  Circle,
  CircleWraper,
  CircleContainer,
  Contracts,
  ContractSession,
  ContractSessionContainer,
} from './styles';

import check from '../../assets/ParaEmpresas/check.svg';
import circle01 from '../../assets/ParaEmpresas/paraEmpresas_01.svg';
import circle02 from '../../assets/ParaEmpresas/paraEmpresas_02.svg';
import circle04 from '../../assets/ParaEmpresas/paraEmpresas_04.svg';
import Balao from '../../assets/ParaEmpresas/balao.svg';
import Header from '../../components/Home/Header';
import NavBar from '../../components/Home/NavBar';
import Footer from '../../components/Home/Footer';

import FaqSection from '../../components/FaqSection';
import CoreService from '../../services/core';
import { useToast } from '../../hooks/toast';

import getValidationErrors from '../../utils/getValidationErrors';
import FileInputSpecial from './Components/FileInputSpecial';
import api from '../../services/api';
import { useLoader } from '../../hooks/loader';
import ContrateAqui from './Components/ContrateAqui';
// import LinkedInTracking from '../../components/LinkedInTracking';
declare global {
  interface Window {
    lintrk: (action: string, options: Record<string, any>) => void;
  }
}

const ParaEmpresas: React.FC = () => {
  const formRef = useRef<FormHandles>(null);
  const services = { coreService: new CoreService() };
  const { addToast } = useToast();
  const [modalMotiva, setModalMotiva] = useState(true);
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [categoriaSet, setCategoriaSet] = useState('');
  const [colaboradorSet, setColaboradorSet] = useState(0);
  const [iscnpj, setIscnpj] = useState<boolean>(true);
  const [outros, setOutros] = useState();

  const submittingRef = useRef(false);

  const { changeLoader, isActive } = useLoader();

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file && file.type === 'application/pdf') {
      setSelectedFile(file);
    } else {
      alert('Por favor, selecione um arquivo pdf!');
    }
  };

  // const [contract, setContract] = React.useState<string>('');

  const modalidadeOptions = [
    { value: 'carga_a_bordo', label: 'Carga a bordo' },
    // { value: 'carga_nos_postos', label: 'Carga nos postos' },
  ];

  const redeOptions = [
    {
      value: 'Google / Pesquisa na internet',
      label: 'Google / Pesquisa na internet',
    },
    { value: 'Instagram', label: 'Instagram' },
    { value: 'Facebook', label: 'Facebook' },
    { value: 'LinkedIn', label: 'LinkedIn' },
    { value: 'Anúncio em Rádio', label: 'Anúncio em Rádio' },
    { value: 'Anúncio em Site/Blog', label: 'Anúncio em Site/Blog' },
    { value: 'Anúncio nos ônibus', label: 'Anúncio nos ônibus' },
    { value: 'Indicação', label: 'Indicação' },
    { value: 'outro', label: 'Outro (qual?)' },
  ];

  const categoriaOptions = [
    { value: 'cpf', label: 'CPF' },
    { value: 'cnpj', label: 'CNPJ' },
  ];

  const issqnOptions = [
    { value: true, label: 'SIM' },
    { value: false, label: 'NÃO' },
  ];

  function showContactModal() {
    const opencontact = document.getElementById('contact');
    opencontact.style.display = 'block';

    setTimeout(() => {
      opencontact.style.display = 'none';
    }, 5000);
  }

  const schema = Yup.object().shape({
    modality: Yup.string().required('Modalidade é obrigatória'),
    company_name: Yup.string().required('Empresa é obrigatório'),
    issqn: Yup.string().required('ISSQN é obrigatório'),
    address_updated: Yup.string().required(
      'Endereço empresarial atualizado é obrigatório',
    ),
    legal_representative: Yup.string().required(
      'Nome do Representante Legal é obrigatório',
    ),
    legal_representative_email: Yup.string().required(
      'Email do Representante Legal é obrigatório',
    ),
    aplicant_name: Yup.string().required('Nome é obrigatório'),
    email: Yup.string()
      .required('E-mail é obrigatório')
      .email('Digite um email válido'),
    phone: Yup.string()
      .required('Telefone é obrigatório')
      .min(14, 'Telefone é obrigatório'),
    employee_number: Yup.string().required(
      'Número de Colaboradores é obrigatório',
    ),
    card_quantity: Yup.string().required('Número de Cartões é obrigatório'),
    company_document: Yup.string()
      .test(
        'cpf-cnpj-validation',
        value => (value.value.length <= 14 ? 'CPF Inválido' : 'CNPJ Inválido'),
        value => {
          if (value) {
            const isCpf = value.length <= 14;
            return isCpf ? isValidCpf(value) : isValidCnpj(value);
          }
          return true;
        },
      )
      .required('CPF ou CNPJ é obrigatório'),
    inscricaofile: Yup.string().required(
      'Arquivo da Inscrição Municipal é obrigatório',
    ),
    inscricao: Yup.string().required(
      'Número da Inscrição Municipal é obrigatório',
    ),
    contratofile: Yup.string(),
    esocialfile: Yup.string(),
    cpffile: Yup.string(),
    categoria: Yup.string(),
    address_proof: Yup.string(),
    rede_social: Yup.string().required('Campo obrigatório'),
  });

  const handleChangeColaborador = (event: any) => {
    const newValue = parseInt(event?.target?.value || '', 10);
    setColaboradorSet(newValue);
  };

  const handleChange = (event: any) => {
    const newValue = event?.value;
    setCategoriaSet(newValue);
  };

  const handleSubmit = useCallback(
    async data => {
      if (submittingRef.current) return;

      submittingRef.current = true;
      changeLoader(true);
      const formData = new FormData();
      formData.append('aplicant_name', data?.aplicant_name);
      formData.append('company_name', data?.company_name);
      formData.append('company_document', data?.company_document);
      formData.append('issqn', data?.issqn);
      formData.append('address_updated', data?.address_updated);
      formData.append('legal_representative', data?.legal_representative);
      formData.append(
        'legal_representative_email',
        data?.legal_representative_email,
      );
      formData.append('card_quantity', data?.card_quantity);
      formData.append('email', data?.email);
      formData.append('modality', data?.modality);
      formData.append('phone', data?.phone);
      formData.append('employee_number', data?.employee_number);
      if (data?.otherinput !== '' && data?.otherinput !== undefined) {
        formData.append('how_know', `${data?.otherinput}`);
      } else {
        formData.append('how_know', data?.rede_social);
      }
      if (data?.cpffile) {
        formData.append('document_file', data?.cpffile);
      }
      if (data?.inscricaofile) {
        formData.append('municipal_registration_file', data?.inscricaofile);
      }
      if (data?.inscricao) {
        formData.append('municipal_registration', data?.inscricao);
      }
      if (data?.contratofile) {
        formData.append('social_contract_file', data?.contratofile);
      }
      if (data?.esocialfile) {
        formData.append('cards_file', data?.esocialfile);
      }

      if (data?.categoria === 'cnpj') {
        formData.append('is_cnpj', 'true');
      } else {
        formData.append('is_cnpj', 'false');
      }
      if (data?.address_proof) {
        formData.append('address_proof', data?.address_proof);
      }
      try {
        formRef.current?.setErrors({});

        await schema.validate(data, {
          abortEarly: false,
        });
        changeLoader(true);
        await api.post('/companies/empresas/contrate-aqui/', formData);

        // await services.coreService.createLead(
        //   data.modality,
        //   data.company_name,
        //   data.company_document,
        //   data.aplicant_name,
        //   data.email,
        //   telefones,
        //   data.employee_number,
        //   data?.cpffile,
        //   data?.inscricaofile,
        //   data?.inscricao,
        // );
        changeLoader(false);
        submittingRef.current = false;
        addToast({
          type: 'success',
          title: `Informações Recebidas`,
          description: `Aguarde o contato dos nossos consultores.`,
        });

        // window.lintrk('track', { conversion_id: 16079305 });

        showContactModal();

        // formRef.current.reset();
      } catch (err: any) {
        changeLoader(false);
        const { ...error } = err;
        console.log(error);
        console.log(error?.response);

        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErrors(err);
          formRef.current?.setErrors(errors);
          return;
        }
        if (error?.response) {
          if (!error?.response?.data?.message) {
            if (error?.response?.data?.document_file) {
              addToast({
                type: 'error',
                title: `Erro no Documento`,
                description: `Verifique o documento de CNPJ/CPF`,
              });
            } else if (error?.response?.data?.cards_file) {
              addToast({
                type: 'error',
                title: `Erro no Documento`,
                description: `Verifique o documento ESOCIAL`,
              });
            } else if (error?.response?.data?.municipal_registration) {
              addToast({
                type: 'error',
                title: `Erro no Documento`,
                description: `Verifique o documento de Inscrição municipal`,
              });
            } else if (error?.response?.data?.social_contract_file) {
              addToast({
                type: 'error',
                title: `Erro no Documento`,
                description: `Verifique o documento de Contrato Social`,
              });
            } else if (error?.response.data?.message) {
              addToast({
                type: 'error',
                title: `${
                  error?.response?.data?.message
                    ? error?.response?.data?.message
                    : error?.response?.data?.detail
                }`,
                description: `${
                  error?.response?.data?.message
                    ? error?.response?.data?.message
                    : error?.response?.data?.detail
                }`,
              });
            } else {
              addToast({
                type: 'error',
                title: `Erro no Documento`,
                description: `Verifique se todos os dados estão preenchidos e anexados.`,
              });
            }
          }
        } else {
          addToast({
            type: 'error',
            title: `Erro no Documento`,
            description: `Verifique se todos os dados estão preenchidos e anexados.`,
          });
        }
      }
    },
    [schema, services.coreService, addToast, changeLoader],
  );

  useEffect(() => {}, [outros]);

  return (
    <>
      <Container>
        <Content>
          <Header />
        </Content>
      </Container>
      <Container backgroundImage className="companies-container">
        <Blur>
          <Content className="content">
            <NavBar />
            <TitleSection>
              <h1 className="h1">
                Vale Transporte: Facilidade para sua empresa e praticidade para
                seus colaboradores
              </h1>
              <span>
                Confira o passo a passo para a contratação do serviço:
              </span>
            </TitleSection>
          </Content>
        </Blur>
      </Container>
      <Container>
        <Content
          style={{
            maxWidth: '100%',
          }}
        >
          <Main>
            <CircleContainer>
              <CircleWraper>
                <Circle>
                  <img src={circle01} alt="Cursor clicando em um quadrado" />
                </Circle>
                <span>
                  Conheça a modalidade que mais combina com o seu negócio
                </span>
              </CircleWraper>

              <CircleWraper>
                <Circle>
                  <img src={circle02} alt="Formulario sendo preenchido" />
                </Circle>
                <span>
                  Preencha o formulário com os dados básicos da empresa
                </span>
              </CircleWraper>

              <CircleWraper>
                <Circle>
                  <img
                    src={Balao}
                    alt="Um balão de fala com reticências dentro"
                    className="balao"
                  />

                  <Mail
                    style={{ fill: 'var(--purple)', fontSize: 35 }}
                    className="envelope"
                  />
                </Circle>
                <span>
                  Você vai receber o contato de um consultor para dar início ao
                  processo de contratação digital
                </span>
              </CircleWraper>

              <CircleWraper>
                <Circle>
                  <img src={circle04} alt="Quadrado com um sinal de check" />
                </Circle>
                <span>
                  Tudo pronto! Agora você já pode utilizar de todas as
                  ferramentas do vale transporte.
                </span>
              </CircleWraper>
            </CircleContainer>
            <div
              style={{
                display: 'flex',
                justifyContent: 'left',
                flexDirection: 'column',
                alignItems: 'left',
                textAlign: 'left',
                width: '100%',
              }}
            >
              <h2 className="h2">Conheça as modalidades disponíveis</h2>

              <div
                className="accordion"
                style={{ display: 'flex', flexDirection: 'column' }}
              >
                <Accordion
                  CollapseIcon={GoTriangleRight}
                  title="Carga a bordo"
                  titleColor="purple3"
                >
                  Modalidade que permite a compra por meio eletrônico de
                  créditos de vale-transporte de acordo com a necessidade de
                  utilização de cada colaborador.
                  <p>
                    A recarga dos cartões acontece dentro de qualquer ônibus do
                    sistema municipal, através do validador.
                  </p>
                  <span className="destaque">PONTOS IMPORTANTES</span>
                  <p>
                    O Transfácil empresta os cartões sem custo. Basta
                    devolvê-los em bom estado. Nesta modalidade a sua empresa
                    tem como benefício a total gestão via web: funcionalidades
                    como emissão de relatórios, compra de créditos on line,
                    saldo, bloqueio de cartões e muito mais. Por isso é cobrado
                    o valor de 1% sobre o total de cada pedido de créditos de
                    Vales-transporte.
                  </p>
                  <p>
                    O contrato é por prazo indeterminado. Você poderá encerrá-lo
                    quando quiser.
                  </p>
                </Accordion>
              </div>
              <div className="accordion">
                <Accordion
                  CollapseIcon={GoTriangleRight}
                  title="Carga nos postos"
                  titleColor="purple3"
                >
                  Modalidade que permite às empresas adquirirem para seus
                  colaboradores créditos eletrônicos de vale-transporte, com
                  recargas dos cartões diretamente no posto de venda do
                  TRANSFÁCIL.
                </Accordion>
              </div>
            </div>
            <Contracts>
              <h2>Contratação de Vale Transporte para Pessoa Jurídica:</h2>
              <ContractSession>
                <ContractSessionContainer>
                  <p>
                    Caso opte por assinar o contrato fisicamente, ele deve ser
                    entregue juntamente com toda a documentaçao necessária no
                    posto de atendimento Floresta - Rua Aquiles Lobo, 504, de
                    08:00 as 17:00 horas.
                  </p>
                  <p>
                    <strong>
                      Atenção: Para contratação presencial é necessario trazer{' '}
                      <strong style={{ color: 'var(--orange)' }}>
                        duas vias
                      </strong>{' '}
                      do contrato preenchidas e assinadas.
                    </strong>
                  </p>
                  <p className="buttons">
                    <a
                      href="/files/contrato_carga-a-bordo_pj.pdf"
                      target="_blank"
                    >
                      <Button color="orange" padding="2" className="button">
                        Contrato Carga a Bordo
                      </Button>
                    </a>
                    <a
                      href="/files/contrato_carga-nos-postos_pj.pdf"
                      target="_blank"
                    >
                      <Button color="orange" padding="1.4" className="button">
                        Contrato Carga nos Postos
                      </Button>
                    </a>
                  </p>
                </ContractSessionContainer>
              </ContractSession>
              <h2 className="pessoaFisica">
                Contratação de Vale Transporte para Pessoa Física:
              </h2>
              <ContractSession>
                <ContractSessionContainer>
                  <p>
                    Caso opte por assinar o contrato fisicamente, ele deve ser
                    entregue juntamente com toda a documentaçao necessária no
                    posto de atendimento Floresta - Rua Aquiles Lobo, 504, de
                    08:00 as 17:00 horas.
                  </p>
                  <p>
                    <strong>
                      Atenção: Para contratação presencial é necessario trazer{' '}
                      <strong style={{ color: 'var(--orange)' }}>
                        duas vias
                      </strong>{' '}
                      do contrato preenchidas e assinadas.
                    </strong>
                  </p>
                  <p className="buttons">
                    <a
                      href="/files/contrato_carga-a-bordo_pf.pdf"
                      target="_blank"
                    >
                      <Button color="orange" padding="2" className="button">
                        Contrato Carga a Bordo
                      </Button>
                    </a>
                    <a
                      href="/files/contrato_carga-nos-postos_pf.pdf"
                      target="_blank"
                    >
                      <Button color="orange" padding="1.4" className="button">
                        Contrato Carga nos Postos
                      </Button>
                    </a>
                  </p>
                </ContractSessionContainer>
              </ContractSession>
            </Contracts>
            <ContrateAqui />
          </Main>
        </Content>
        <Content>
          <FaqSection />
        </Content>
        {modalMotiva && (
          <ModalMotiva
            show={modalMotiva}
            text="Digite o ID numérico do titular e você receberá no email cadastrado instruções."
            handleClose={() => setModalMotiva(false)}
          />
        )}
        {/* <LinkedInTracking /> */}
      </Container>
      <Container>
        <Footer />
      </Container>
    </>
  );
};

export default ParaEmpresas;
